import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { projectId: Number }
  static targets = [ "btn", "clearBtn" ]

  filter(event) {
    const type = event.params.filter

    this.btnTargets.forEach((btn) => {
      btn.classList.remove("active", "bg-indigo-600", "text-white", "border-indigo-600")
      btn.classList.add("bg-white", "dark:bg-gray-900", "text-gray-700", "dark:text-gray-300", "border-gray-300", "dark:border-gray-700")
    })

    event.currentTarget.classList.add("active", "bg-indigo-600", "text-white", "border-indigo-600")
    event.currentTarget.classList.remove("bg-white", "dark:bg-gray-900", "text-gray-700", "dark:text-gray-300", "border-gray-300", "dark:border-gray-700")

    this.clearBtnTarget.classList.remove("hidden")

    const panel = document.getElementById("filtered-issues-panel")
    panel.classList.remove("hidden")

    const frame = panel.querySelector('turbo-frame[id="filtered-issues"]')
    if (frame) {
      const locale = new URLSearchParams(window.location.search).get("locale") || ""
      const localeParam = locale ? `&locale=${locale}` : ""
      frame.src = `/projects/${this.projectIdValue}/issues?filter=${type}${localeParam}`
    }
  }

  clear() {
    document.getElementById("filtered-issues-panel").classList.add("hidden")

    this.btnTargets.forEach((btn) => {
      btn.classList.remove("active", "bg-indigo-600", "text-white", "border-indigo-600")
      btn.classList.add("bg-white", "dark:bg-gray-900", "text-gray-700", "dark:text-gray-300", "border-gray-300", "dark:border-gray-700")
    })

    this.clearBtnTarget.classList.add("hidden")

    const frame = document.querySelector('turbo-frame[id="filtered-issues"]')
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }
}
